import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=5d32473e&scoped=true&"
import script from "./Settings.vue?vue&type=script&lang=js&"
export * from "./Settings.vue?vue&type=script&lang=js&"
import style0 from "../../Style/template-settings.scss?vue&type=style&index=0&id=5d32473e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d32473e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d32473e')) {
      api.createRecord('5d32473e', component.options)
    } else {
      api.reload('5d32473e', component.options)
    }
    module.hot.accept("./Settings.vue?vue&type=template&id=5d32473e&scoped=true&", function () {
      api.rerender('5d32473e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/Settings/Settings.vue"
export default component.exports